<template>
  <div>
    <drawer :title="addEditTitle" size="690px" :dialogShow="addEditShow" @handleChange="back">
      <div slot="body">
        <div class="pay-mains equities_apply">
          <div class="" v-for="item,index in params.remarkList" :key="index">
            {{item}}
          </div>
          <div style="display: flex;justify-content: center;" class="mt20" v-if="addFlag == 'yes'">
            <el-button type="primary" style="width: 200px;" @click="applyImmediately">立即申请</el-button>
          </div>
         
          <div class="mb10">申请记录</div>
          <el-table :data="list" :max-height="height - 535" header-cell-class-name="table_header_bgcolor">
            <el-table-column prop="subsidyTypeCn" label="补贴类型"></el-table-column>
            <el-table-column prop="staffName" label="补贴店员" width="auto"></el-table-column>
            <el-table-column prop="auditAmount" width="auto" label="补贴金额">
              <template slot-scope="scope">
                <span class="moneys">￥{{ scope.row.auditAmount == 0 ?
                  scope.row.applyAmount : scope.row.auditAmount }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="auditStatusCn" label="审核状态" width="auto"></el-table-column>
            <el-table-column prop="oxCtime" width="160" label="创建时间">
              <template slot-scope="scope">
                <span>{{ formatDate(scope.row.oxCtime) }}</span>
              </template>
            </el-table-column>
          </el-table>
          <paging :currentPage="query.start" :totalCount="totalCount" @doPageQuery="doDataQuery"></paging>
        </div>
      </div>
    </drawer>
    <add ref="addForm" @change="handleChange"></add>
  </div>
</template>

<script>
import minxin from "../../../../assets/javascript/minxin.js";
import drawer from "../../../../components/common/drawer";
import add from "../add.vue";
export default {
  mixins: [minxin],
  components: {
    drawer,
    add
  },
  data() {
    return {
      url: this.$url.subsidyApply.list,
      urlCount: this.$url.subsidyApply.count,
      height: this.$store.getters.MainHeight,
      addEditShow: false,
      addEditTitle: "店员权益详情",
      addFlag: 'no',
      headerImg: require("../../../../assets/images/headerImg.png"),
      params: {
        staffId: '',
        staffName: '',
        subsidyType: '',
        subsidyTypeCn: '',
        remarkList: []
      },
      query: {
        subsidyType: "",
        staffId: "",
        auditStatusList: ['pass', 'wait'],
        start: 0,
        size: 20
      },
      form: {
        itemList: []
      },
      list: []
    };
  },
  methods: {
    //  页面初始化函数
    init(org) {
      this.params.staffId = org.staffId;
      this.params.staffName = org.staffName;
      this.params.subsidyType = org.subsidyType;
      this.params.subsidyTypeCn = org.subsidyTypeCn;
      this.query.staffId = org.staffId;
      this.query.subsidyType = org.subsidyType;
      this.addFlag = org.addFlag;
      this.getBySubsidyType();
      this.totalCounts();
      this.addEditShow = true;
    },
    totalCounts() {
      this.$api.post(this.urlCount, this.query).then(res => {
        this.getData();
        this.totalCount = res;
      }).catch(error => { });
    },
    getBySubsidyType () {
      this.$api.get(this.$url.subsidySet.getBySubsidyType, {
        salaryModuleType: 'subsidySalary',
        subsidyType: this.params.subsidyType,
        dataMonth: this.formatMonth(new Date())
      }).then(res => {
        if (res) {
          this.params.remarkList = res.remarkList;
        }
      });
    },
    applyImmediately () {
      this.$refs["addForm"].$emit("set", {
        subsidyType: this.params.subsidyType,
        subsidyTypeCn: this.params.subsidyTypeCn,
        staffId: this.params.staffId,
        staffName: this.params.staffName
      });
    },
    handleChange () {
      this.totalCounts();
      this.$emit("change", true);
    },
    back () {
      this.addEditShow = false;
    }
  }
};
</script>

<style scoped lang="less">
.equities_apply {
  padding: 10px;
  .nav_list {
    .nav_list_tag {
      display: inline-block;
      padding: 2px 4px;
      color: #257FFA;
	    background: #E7F5FF;
    }
  }
  .member-msg {
    padding: 16px 16px 0;
    .member-border {
      width: 100%;
      background-size: 100% 100%;
      color: white;
      display: flex;
      align-items: center;
      border-radius: 10px;
      padding: 12px 15px;
      background: #3388ff;
      box-sizing: border-box;

      .member-box {
        margin-left: 10px;

        .mobile {
          line-height: 1.6;
          margin-right: 10px;
        }
      }
    }
  }
}

</style>